export const SECONDS_PER_DAY = 24 * 60 * 60;

export const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
